export type AnyEvent = MouseEvent | TouchEvent;
export type Listener = (e: AnyEvent) => void;

export class ClickOutsideListener {
  private handlers: Array<Listener> = [];

  constructor() {
    document.addEventListener('mousedown', this.listener);
    document.addEventListener('touchstart', this.listener);
  }

  listener = (e: AnyEvent) => {
    this.handlers.forEach((fn) => fn(e));
  };

  getHandlers = () => this.handlers;

  on = (handler: Listener) => {
    this.handlers.push(handler);
  };

  off = (handler: Listener) => {
    this.handlers = this.handlers.filter((fn) => handler !== fn);
  };
}
